function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlohaaWhiteLogoNoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.201,
    height: 29.322,
    viewBox: "0 0 146.201 29.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "White logo - no background"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3116"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2345",
    d: "M589.349 654.887a3.665 3.665 0 0 1-3.583 4.435h-27.233a3.665 3.665 0 0 1-3.584-4.435 17.594 17.594 0 0 1 33.368-3.233 17.433 17.433 0 0 1 1.032 3.233zm-30.814-13.5a3.649 3.649 0 0 0 2-.6 21.213 21.213 0 0 1 23.219 0 3.665 3.665 0 1 0 4.016-6.133 28.544 28.544 0 0 0-31.25 0 3.666 3.666 0 0 0 2.011 6.732z",
    transform: "translate(-554.866 -630.002)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2346",
    d: "M44.127 271.885h5.006v16.476h-5.006v-1.648c-.222.57-1.711 1.964-4.246 1.964-3.77 0-8.111-2.693-8.111-8.587a8.12 8.12 0 0 1 8.111-8.491 5.462 5.462 0 0 1 4.246 1.806zm-3.517 12.389c2.06 0 3.739-1.426 3.739-4.182 0-2.661-1.679-4.087-3.739-4.087a4.137 4.137 0 0 0 0 8.27zm16.761-18.314v22.4h-5.006v-22.4zm11.407 5.64a8.609 8.609 0 0 1 8.682 8.587c0 5.8-4.943 8.492-8.682 8.492s-8.682-2.693-8.682-8.492a8.609 8.609 0 0 1 8.682-8.587zm0 4.4a4.144 4.144 0 1 0 3.866 4.182A3.9 3.9 0 0 0 68.778 276zm21.514-4.372c3.073 0 6.21 2.06 6.21 7.287v9.442H91.5v-9.094c0-2.5-.855-3.3-2.44-3.3-2.25 0-3.549 2.186-3.866 3.137v9.252h-5.01v-22.4h5.006v8.777a5.7 5.7 0 0 1 5.102-3.097zm21.1.253h5.008v16.476h-5.006v-1.648c-.222.57-1.711 1.964-4.246 1.964-3.77 0-8.111-2.693-8.111-8.587a8.12 8.12 0 0 1 8.111-8.491 5.462 5.462 0 0 1 4.246 1.806zm-3.517 12.389c2.06 0 3.739-1.426 3.739-4.182 0-2.661-1.679-4.087-3.739-4.087a4.137 4.137 0 0 0 0 8.27zm23.605-12.389h5.006v16.476h-5.006v-1.648c-.222.57-1.711 1.964-4.246 1.964-3.77 0-8.111-2.693-8.111-8.587a8.12 8.12 0 0 1 8.111-8.491 5.462 5.462 0 0 1 4.246 1.806v-1.521zm-3.517 12.389c2.059 0 3.739-1.426 3.739-4.182 0-2.661-1.679-4.087-3.739-4.087a4.137 4.137 0 0 0 0 8.27z",
    transform: "translate(9.713 -259.356)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlohaaWhiteLogoNoBackground);
export default __webpack_public_path__ + "static/media/AlohaaWhiteLogoNoBackground.09081b9d13903615ec9fa1e9597fe6e2.svg";
export { ForwardRef as ReactComponent };